import * as React from 'react';
import { Helper } from '../../../../Helper';
import { Environment } from '../../../../services/Environment';
import { IEnvironment } from '../../../../interfaces/IEnvironment';
import * as styles from './OrgAssetFolder.css';

export interface IAOrgAssetFolderProps {
  name: string;
  environment: IEnvironment;
  tenant: string;
  token: string;
  thumbnail?: string;
  onClick: () => void;
}

export interface IAOrgAssetFolderState {
}

export class IAOrgAssetFolder extends React.Component<IAOrgAssetFolderProps, IAOrgAssetFolderState> {
  constructor(props: IAOrgAssetFolderProps) {
    super(props);
    this.state = {
    };
  }

  public render(): JSX.Element {
    return (
      <div
        className={styles.IA_OrgAssetFolder}
        style={{
          backgroundImage: this.props.thumbnail ? `url('${Helper.getImageUrl(Environment.getEnvironmentForImageAPI(this.props.environment), this.props.tenant, this.props.token, this.props.thumbnail, undefined, "StandardSmall")}')` : undefined,
          backgroundSize: this.props.thumbnail ? "cover" : undefined,
          backgroundRepeat: this.props.thumbnail ? "no-repeat" : undefined,
          backgroundPosition: this.props.thumbnail ? "center" : undefined,
        }}
        onClick={() => this.props.onClick()}
      >
        <div className={styles.IA_OrgAssetFolderImage}>
          {this.props.name}
        </div>
      </div>
    );
  }
}
